// extracted by mini-css-extract-plugin
export var videoHero = "_dv-4";
export var videoHeroImage = "_dv-5";
export var videoHeroOverlay = "_dv-6";
export var videoHeroSubtitle = "_dv-8";
export var videoHeroText = "_dv-7";
export var videoLauncher = "_dv-0";
export var videoLauncherIcon = "_dv-1";
export var videoLauncherSubtitle = "_dv-3";
export var videoLauncherTitle = "_dv-2";
export var videoPlayer = "_dv-a";
export var videoPlayerWrap = "_dv-9";